import { render, staticRenderFns } from "./addStandardDiaglog.vue?vue&type=template&id=df5dd692&scoped=true"
import script from "./addStandardDiaglog.vue?vue&type=script&lang=js"
export * from "./addStandardDiaglog.vue?vue&type=script&lang=js"
import style0 from "./addStandardDiaglog.vue?vue&type=style&index=0&id=df5dd692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5dd692",
  null
  
)

export default component.exports